import React from 'react'

import { useAppStore } from 'Stores/appStoreModuleFed'
import { Button, Modal, ModalControlsStyled } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import {
  GoogleDisconnectedFirstParagraph,
  GoogleDisconnectedModalStyled,
  GoogleDisconnectedSecondParagraph,
} from 'Features/GoogleDisconnectedModal/GoogleDisconnectedModal.styled'
import { useNavigate } from 'react-router-dom'

export const GoogleDisconnectedModal = () => {
  const { t } = useTranslation('accountSettings')
  const { setModalToShow, modalToShowData } = useAppStore()
  const navigate = useNavigate()

  const notNowClicked = () => {
    localStorage.setItem('googleDisconnectedModalSeen', 'true')
    setModalToShow('')
  }

  return (
    <Modal
      title={t('google_disconnect_modal.title')}
      isOpen={true}
      onOpenChange={() => {}}
      onCloseClick={notNowClicked}
    >
      <GoogleDisconnectedModalStyled>
        <GoogleDisconnectedFirstParagraph>
          {t('google_disconnect_modal.account_disconnected', { ids: modalToShowData || [] })}
        </GoogleDisconnectedFirstParagraph>
        <GoogleDisconnectedSecondParagraph>
          {t('google_disconnect_modal.to_reconnect')}
        </GoogleDisconnectedSecondParagraph>
      </GoogleDisconnectedModalStyled>
      <ModalControlsStyled>
        <Button
          variant={'outline'}
          text={t('google_disconnect_modal.not_now')}
          onClick={notNowClicked}
        />
        <Button
          text={t('google_disconnect_modal.reconnect')}
          onClick={() => {
            navigate('/paid-marketing/platforms')
            setModalToShow('')
          }}
        />
      </ModalControlsStyled>
    </Modal>
  )
}
